const setDate = (date) => {
  const fields = document.querySelectorAll("[data-date]");   
  const arrMonths = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

  fields.forEach(field => {
    field.innerHTML = `${date.getDate()}&nbsp;${arrMonths[date.getMonth()]}`
  })
}

export default setDate;